
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { LessonCreateDto } from '../../Manipulate/CoursesObjects/LessonDto';

@Injectable({
  providedIn: 'root'
})
export class LessonVideoService {
  private apiUrl = environment.apiUrl + '/lesson-video';

  constructor(private http: HttpClient) { }

  public AddLessonVideo(lessonId:string, file:FormData) : Observable<any>{
    return this.http.post<any>(`${this.apiUrl}/${lessonId}/upload`,file);
  }

  public AddLessonAndTranscodeVideo(lessonId:string, file:FormData) : Observable<any>{
    return this.http.post<any>(`${this.apiUrl}/${lessonId}/upload-transcode`,file);
  }

  public SetYoutubeVideo(lessonId:string, url:string) : Observable<any>{
    return this.http.post<any>(`${this.apiUrl}/${lessonId}/youtube`, { url });
  }

  public PostMaterial(lessonId:string) : Observable<any>{
    return this.http.post<any>(`${this.apiUrl}/${lessonId}/transcode`,'');
  }

  public PlayLesson(lessonId:string) : Observable<any>{
    return this.http.get(`${this.apiUrl}/${lessonId}/play`);
  }

}
